export default class ShipBoardDetailsModel{
    constructor(
        shipBoardId,
        shipName,
        imoNo,
        type,
        dwt,
        mainEngineMake,
        mainEngineType,
        mainEnginePower,
        auxEngineMake,
        auxEngineType,
        auxEnginePower,
        auxBoilerMake,
        auxBoilerType,
        auxBoilerPower,
        joiningDate,
        leavingDate,
        days,
        userId
    ){
        this.shipBoardId = shipBoardId === undefined ? "" : shipBoardId;
        this.shipName = shipName === undefined ? "" : shipName;
        this.imoNo = imoNo === undefined ? "" : imoNo;
        this.type = type === undefined ? "" : type;
        this.dwt = dwt === undefined ? "" : dwt;
        this.mainEngineMake = mainEngineMake === undefined ? "" : mainEngineMake;
        this.mainEngineType = mainEngineType === undefined ? "" : mainEngineType;
        this.mainEnginePower = mainEnginePower === undefined ? "" : mainEnginePower;
        this.auxEngineMake = auxEngineMake === undefined ? "" : auxEngineMake;
        this.auxEngineType = auxEngineType === undefined ? "" : auxEngineType;
        this.auxEnginePower = auxEnginePower === undefined ? "" : auxEnginePower;
        this.auxBoilerMake = auxBoilerMake === undefined ? "" : auxBoilerMake;
        this.auxBoilerType = auxBoilerType === undefined ? "" : auxBoilerType;
        this.auxBoilerPower = auxBoilerPower === undefined ? "" : auxBoilerPower;
        this.joiningDate = joiningDate === undefined ? "" : joiningDate;
        this.leavingDate = leavingDate === undefined ? "" : leavingDate;
        this.days = days === undefined ? 0 : days;
        this.userId = userId === undefined ? 0 : userId;
    }
}